<template>
  <el-dialog title="角色" :visible.sync="currentValue" width="auto" class="dialog-center" append-to-body>
    <div class="user-edit" v-loading="loading">
      <el-transfer v-model="roles_name" :data="dataset" :titles="['所有角色','已拥有角色']" :filterable="true">
        <span slot-scope="{ option }" :title="option.label">{{ option.label }}</span>
      </el-transfer>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <span class="cancel text-btn-active" @click="$emit('close')" style="margin-right: 24px;">取消</span>
        <el-button size="mini" type="primary" @click="save">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import roleApi from '@/services/api/role/role'
import userApi from '@/services/api/user/user'
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  props: ['paramsSet', 'value'],
  data() {
    return {
      loading: false,
      roles_name: [],
      dataset: []
    }
  },
  watch: {
    'paramsSet.dialogVisible': {
      handler() {
        if (this.paramsSet.dialogVisible) {
          this.init()
        }
      },
      deep: true
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('permissions/permissions', ['permissionsIndex']),
    async init() {
      this.loading = true
      await roleApi.getRoleList({}).then(res => {
        res.data.forEach(res => {
          res.key = res.role_name
          res.label = res.role_name
        })
        this.dataset = JSON.parse(JSON.stringify(res.data))
      }).catch(err => { })
      await this.userRolesShowByUid(this.paramsSet.uid)
      this.loading = false
    },
    userRolesShowByUid(uid) {
      return userApi.userRolesShowByUid({ uid }).then(res => {
        this.roles_name = res.roles.map(res => res.role_name)
      })
    },
    save() {
      let parmas = {
        uid: this.paramsSet.uid,
        roles_name: this.roles_name
      }
      userApi.updateUserRoles(parmas).then(res => {
        this.$message({ message: '设置用户角色成功', type: 'success' });
        this.permissionsIndex()
        this.$emit('complete')
      })
    }
  }
}
</script>
<style lang="scss">
.user-edit {
  .dialog-footer {
    margin-top: 20px;
    display: block;
  }
}
</style>
